/* eslint-disable no-use-before-define */
/* eslint-disable react/prop-types */
import { Box, useTheme } from '@mui/material'
import clsx from 'clsx'
import React from 'react'
import { Helmet } from 'react-helmet-async'
import { createDataset } from '../helpers/others'

const Fa: React.FC<FaProps> = ({
  family = 'light',
  name,
  size = 'xl',
  color,
  block = false,
}) => {
  const theme = useTheme()

  return (
    <>
      <Helmet>
        <script
          src="https://kit.fontawesome.com/99c791a429.js"
          crossOrigin="anonymous"
        />
      </Helmet>
      <Box
        component="i"
        {...createDataset({ block })}
        {...(color && ['error', 'secondary'].includes(color)
          ? { ...createDataset({ color }) }
          : { style: { color } })}
        className={clsx(`fa-${family}`, `fa-${name}`, `fa-${size}`)}
        sx={{
          height: '1em',
          aspectRatio: '1',
          lineHeight: '1 !important',
          verticalAlign: 'revert !important',
          textAlign: 'center',

          '&[data-block]': {
            display: 'block',
          },
          '&[data-color="error"]': {
            color: theme.palette.error.dark,
          },
          '&[data-color="secondary"]': {
            color: theme.palette.secondary.dark,
          },
        }}
      />
    </>
  )
}

type FaProps = {
  name: string
  family?: 'light' | 'brands' | 'solid' | 'regular'
  size?: '2xs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl'
  color?: 'error' | 'secondary' | (string & {})
  block?: boolean
}

export { Fa }
